import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Card, Tag, Divider, Progress } from "antd";
import {
  CloudServerOutlined,
  DatabaseOutlined,
  ThunderboltOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";

import axios from "axios";
import { endpoints } from "./caminhoApi";

const StatusModal = ({ visible, onClose }) => {

  const [data, setData] = useState(null);
  const [latency, setLatency] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchHealth = async () => {

    try {

      const start = Date.now();

      const res = await axios.get(endpoints.getHealth);

      const end = Date.now();

      const d = res.data;

      setLatency(end - start);

      setData(d);

      setLastUpdate(new Date());

    } catch (err) {

      console.error("health error", err);

    }

  };

  useEffect(() => {

    if (!visible) return;

    fetchHealth();

    const interval = setInterval(fetchHealth, 5000);

    return () => clearInterval(interval);

  }, [visible]);

  if (!data) {

    return (
      <Modal open={visible} footer={null} onCancel={onClose}>
        Loading monitoring...
      </Modal>
    );

  }

  // STATUS CALCULATIONS

  const backendStatus = data.status === "ok";

  const cacheStatus = data.cache.ageSeconds < 10;

  const memoryStatus =
    data.memory.heapUsedMB < data.memory.rssMB * 0.8;

  const totalRuns =
    data.scheduler.successesLastHour +
    data.scheduler.errorsLastHour;

  const errorRate =
    totalRuns > 0
      ? data.scheduler.errorsLastHour / totalRuns
      : 0;

  const schedulerStatus = errorRate < 0.05;

  const services = [
    backendStatus,
    cacheStatus,
    schedulerStatus,
    memoryStatus
  ];

  const healthScore =
    Math.round(
      (services.filter(Boolean).length / services.length) * 100
    );

  const ServiceRow = ({ icon, name, ok }) => (

    <Row justify="space-between" style={{ marginBottom: 8 }}>

      <Col>
        {icon} {name}
      </Col>

      <Col>

        <Tag color={ok ? "success" : "warning"}>
          {ok ? "Operational" : "Degraded"}
        </Tag>

      </Col>

    </Row>

  );

  return (

    <Modal
      title={<><CloudServerOutlined /> System Monitoring</>}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={520}
    >

      {/* HEALTH BAR */}

      <Card size="small" style={{ marginBottom: 16 }}>

        <div style={{ marginBottom: 6 }}>
          System Health
        </div>

        <Progress
          percent={healthScore}
          status={healthScore === 100 ? "success" : "active"}
        />

      </Card>

      {/* METRICS */}

      <Row gutter={10} style={{ marginBottom: 14 }}>

        <Col span={12}>
          <Card size="small">

            <div style={{ fontSize: 11, opacity: 0.7 }}>
              Players
            </div>

            <div style={{ fontSize: 18 }}>
              {data.cache.players}
            </div>

          </Card>
        </Col>

        <Col span={12}>
          <Card size="small">

            <div style={{ fontSize: 11, opacity: 0.7 }}>
              Uptime
            </div>

            <div style={{ fontSize: 18 }}>
              {Math.floor(data.uptimeSeconds / 3600)}h
            </div>

          </Card>
        </Col>

      </Row>

      {/* SERVICES */}

      <Card size="small" style={{ marginBottom: 16 }}>

        <ServiceRow
          icon={<CloudServerOutlined />}
          name="Application Server"
          ok={backendStatus}
        />

        <ServiceRow
          icon={<ThunderboltOutlined />}
          name="Cache Engine"
          ok={cacheStatus}
        />

        <ServiceRow
          icon={<ClockCircleOutlined />}
          name="Background Scheduler"
          ok={schedulerStatus}
        />

        <ServiceRow
          icon={<DatabaseOutlined />}
          name="Memory Usage"
          ok={memoryStatus}
        />

      </Card>

      <Divider />

      {/* SYSTEM DETAILS */}
      {/* 
      <Row justify="space-between" style={{ fontSize: 12 }}>

        <Col>Cache Age</Col>

        <Col>{data.cache.ageSeconds}s</Col>

      </Row>

      <Row justify="space-between" style={{ fontSize: 12 }}>

        <Col>Scheduler Delay</Col>

        <Col>{data.scheduler.delaySeconds}s</Col>

      </Row>
      */}
      <Row justify="space-between" style={{ fontSize: 12 }}>

        <Col>Error Rate</Col>

        <Col>{(errorRate * 100).toFixed(1)}%</Col>

      </Row>

      <Row justify="space-between" style={{ fontSize: 12 }}>

        <Col>API Latency</Col>

        <Col>{latency} ms</Col>

      </Row>

      <Divider style={{ margin: "10px 0" }} />

      <Row justify="end" style={{ fontSize: 11, opacity: 0.6 }}>
        UI updated: {lastUpdate?.toLocaleTimeString()}
      </Row>

    </Modal>

  );

};

export default StatusModal;